<template>
  <div class="ds-filter-bar">
    <span class="ds-filter-bar__label">Actieve filters:</span>
    <div class="ds-filter-bar__chips">
      <span v-for="chip in chips" :key="chip.key" class="ds-filter-bar__chip">
        {{ chip.label }}
        <button
          class="ds-filter-bar__remove"
          title="Filter verwijderen"
          @click="$emit('remove', chip.key)"
        >
          ✕
        </button>
      </span>
    </div>
    <button class="ds-filter-bar__clear" title="Alle filters wissen" @click="$emit('clear-all')">
      Alle filters wissen
    </button>
  </div>
</template>

<script>
/**
 * Generic active-filter chip bar.
 *
 * Presentation comes from the design system (styles/ds/_filter-bar.scss), which
 * is emitted globally rather than under `.ds-root` — this component also renders
 * on pages that have not been migrated yet, and has to look the same on all of
 * them. It therefore carries no styles of its own.
 *
 * Props:
 *   chips: { key: string, label: string }[]
 *
 * Emits:
 *   remove(key)   — user removed a single chip
 *   clear-all     — user cleared all chips
 */
export default {
  name: 'TableFilterChips',
  props: {
    chips: { type: Array, required: true },
  },
  emits: ['remove', 'clear-all'],
}
</script>
